import { mapState } from 'vuex'

import { setFiltersByBusiness } from '@/utils/transformers/filters'
import { BUSINESS_TYPE_MAP } from '@/filters/business-type'
import { priceValues } from '@/utils/transformers/filters/prices'
import { areaValues } from '@/utils/transformers/filters/areas'
import { URLS } from '@/utils/constants'
import select from '@/utils/select'
import { getVariationOf } from '@/store/experimentations/selectors'
import { CTA_BUYING_POWER_CALCULATOR } from '@/store/experimentations'

import ozToggle from '@/components/oz-toggle'
import newUnitType from '@/components/filters/new-unit-type'
import newAddressTypeahead from '@/components/filters/new-address-typeahead'
import ozToggleZapway from '@/components/filters/oz-toggle-zapway'
import ozToggleDatazap from '@/components/filters/oz-toggle-datazap'
import ozToggleDisplayAddressType from '@/components/filters/oz-toggle-display-address-type'
import ozToggleTotalPrice from '@/components/filters/oz-toggle-total-price'
import ozListingCode from '@/components/filters/oz-listing-code'
import ozAdvertiserId from '@/components/filters/oz-advertiser-id'
import ozToggleTotalArea from '@/components/filters/oz-toggle-total-area'

// DESKTOP ONLY
import ozFiltersApplied from '@/components/filters/oz-filters-applied'
import ozAmenities from '../components/oz-amenities'
import ozBusinessType from '../components/oz-business-type'
import ozDevelopmentType from '../components/oz-development-type'
import ozRentalTypes from '../components/oz-rental-types'
import ozBuyingPowerCalculatorButton from '../components/oz-buying-power-calculator-button'

import ozPrices from '../components/oz-prices'
import ozAmount from '../components/oz-amount'
import ozAreas from '../components/oz-areas'

export default {
  name: 'oz-filters-desktop',

  props: {
    isResultPage: { type: Boolean },
    glossary: { type: Object, required: true },
    loading: { type: Object },
  },

  computed: {
    ...mapState({
      filters: (state) => state.results.filters,
    }),

    rentTotalPrice () {
      const { rentTotalPrice, rentalTotalPriceMin, rentalTotalPriceMax } = this.filters
      return Boolean(rentTotalPrice || rentalTotalPriceMax || rentalTotalPriceMin)
    },

    totalArea () {
      const { totalAreasMin, totalAreasMax } = this.filters
      return Boolean(totalAreasMin || totalAreasMax)
    },

    isRental () {
      const { RENTAL } = BUSINESS_TYPE_MAP
      return this.filters.business === RENTAL
    },

    isSale () {
      const { SALE } = BUSINESS_TYPE_MAP
      return this.filters.business === SALE
    },

    prices () {
      return priceValues(this.rentTotalPrice, this.filters)
    },

    areas () {
      return areaValues(this.totalArea, this.filters)
    },

    amountTypes () {
      const { bedrooms = '', bathrooms = '', parkingSpaces = '' } = this.filters

      return [
        {
          title: 'Quartos',
          singularTitle: 'quarto',
          model: 'bedrooms',
          filters: bedrooms.toString(),
          class: 'js-bedrooms',
        },
        {
          title: 'Banheiros',
          singularTitle: 'banheiro',
          model: 'bathrooms',
          filters: bathrooms.toString(),
          class: 'js-bathrooms',
        },
        {
          title: 'Vagas',
          singularTitle: 'vaga',
          model: 'parkingSpaces',
          filters: parkingSpaces.toString(),
          class: 'js-parking-spaces',
        },
      ]
    },

    hasTransportNearBy () {
      const { transportNearBy } = this.filters
      return Boolean(transportNearBy)
    },

    hasVirtualTour () {
      const { hasVirtualTour } = this.filters
      return Boolean(hasVirtualTour)
    },

    isRoutePathSale () {
      const { params: { pathMatch } } = this.$route
      return pathMatch === URLS.ZAP.MAIN.PATHS.SALE
    },

    buyingPowerCalculatorAB: select(
      getVariationOf(CTA_BUYING_POWER_CALCULATOR),
      ([name]) => name,
    ),

    shouldRenderBuyingPowerCalculatorButton () {
      return this.buyingPowerCalculatorAB === 'filtro'
    },
  },

  methods: {
    onFiltersUpdate (filters) {
      const data = setFiltersByBusiness({ ...this.filters, ...filters })

      this.$emit('filters:update', data)
    },

    onTransportNearByChange (value) {
      const distance = '2'
      this.onFiltersUpdate({ transportNearBy: value ? distance : null })
    },

    onVirtualTourChange (value) {
      this.onFiltersUpdate({ hasVirtualTour: value })
    },
  },

  components: {
    newUnitType,
    newAddressTypeahead,
    ozAmenities,
    ozBusinessType,
    ozToggleZapway,
    ozPrices,
    ozAmount,
    ozAreas,
    ozToggle,
    ozToggleDatazap,
    ozToggleDisplayAddressType,
    ozToggleTotalPrice,
    ozListingCode,
    ozDevelopmentType,
    ozRentalTypes,
    ozFiltersApplied,
    ozAdvertiserId,
    ozToggleTotalArea,
    ozBuyingPowerCalculatorButton,
  },
}
